import * as Toastr from 'toastr'
import { getApiErrorMessage } from './api-error'

export default class Alert {

    static configureToastr() {
        Toastr.options.newestOnTop = true;
        Toastr.options.closeButton = true;
        Toastr.options.closeMethod = 'fadeOut';
        Toastr.options.closeDuration = 300;
        Toastr.options.closeEasing = 'swing';

        if (!document.getElementById('toastr-multiline-style')) {
            const style = document.createElement('style');
            style.id = 'toastr-multiline-style';
            style.textContent = '#toast-container .toast-message { white-space: pre-line; }';
            document.head.appendChild(style);
        }
    }

    static info(text = '', title = _t("master.info")) {
        this.configureToastr();
        Toastr.info(text, title);
    }

    static warning(text = '', title = _t("master.alerta")) {
        this.configureToastr();
        Toastr.warning(text, title);
    }

    static error(text = '', title = _t("master.error")) {
        this.configureToastr();
        Toastr.error(text, title);
    }

    static success(text = '', title = _t("master.exitoso")) {
        this.configureToastr();
        Toastr.success(text, title);
    }

    /** Mensaje seguro desde error de API; nunca pasa el objeto Error crudo a Toastr. */
    static fromApiError(error, fallback = 'Ocurrió un error inesperado. Intente de nuevo o contacte a soporte.') {
        this.error(getApiErrorMessage(error, fallback));
    }
}